export default {
  data() {
    return {
      honoreDedicace: "",
      prenomDedicace: "",
      nomDedicace: "",
      adresseDedicace: "",
      villeDedicace: "",
      provinceDedicace: "",
      codePostalDedicace: "",
      consentementDedicace: false,
    }
  }

}